import { Col, Row } from "taltech-styleguide";

type Props = {
  data: {
    course: string;
    student: string;
    assignment: string;
    buildingConfig: string;
    buildingName: string;
    buildingDescription: string;
  };
};

export const GeneralInfoComponent: React.FC<Props> = ({ data }) => {
  return (
    <div className="build-spec-section">
      <div className="section-header">
        <h5>General Info</h5>
      </div>
      <div className="section-body">
        <Row>
          <label>
            <span>Course:</span> {data.course}
          </label>
        </Row>
        <Row>
          <label>
            <span>Student:</span> {data.student}
          </label>
        </Row>
        <Row>
          <label>
            <span>Assignment:</span> {data.assignment}
          </label>
        </Row>
        <Row>
          <label>
            <span>Building Configuration:</span> {data.buildingConfig}
          </label>
        </Row>
        <Row>
          <label>
            <span>Building Name:</span> {data.buildingName}
          </label>
        </Row>
        <Row>
          <label>
            <span>Building Description:</span> {data.buildingDescription}
          </label>
        </Row>
      </div>
    </div>
  );
};
